import * as React from 'react';
import styled from 'styled-components';

// Definição do tipo para as props do BotaoEstilizado
interface BotaoEstilizadoProps {
  corFundo: string;
  corHover: string;
}

// Criação do componente estilizado Botao que aceita props para cores
const BotaoEstilizado = styled.button<BotaoEstilizadoProps>`
  width: 190px;
  height: 40px;
  color: white;
  background-color: ${props => props.corFundo};
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: large;

  &:hover {
    background-color: ${props => props.corHover};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// Componente Botao que utiliza BotaoEstilizado
interface BotaoProps {
  texto: string;
  corFundo: string;
  corHover: string;
  onClick: () => void; 
}

const Botao = ({ texto, corFundo, corHover, onClick }: BotaoProps) => {
  return (
    <BotaoEstilizado corFundo={corFundo} corHover={corHover} onClick={onClick}>
      {texto}
    </BotaoEstilizado>
  );
};

export default Botao;
